/*==========================================================================================================================================================================*/
/* Ассортимент */
var assortmentSection = document.querySelector('.assortment');

if (assortmentSection) {
  var toggleActiveTab = function(id) {
    if (id === 1) {
      id = parseInt(assortInitChildTab.getAttribute('data-target-tab-id'));
    }

    var tab = document.querySelector("[data-target-tab-id=\"" + id + "\"]");
    var currentTabs = document.querySelectorAll("." + assortTabActiveClass);
    var tabBody = document.getElementById("assort-tab-" + id);

    Array.prototype.forEach.call(currentTabs, function(e) {
      e.classList.remove(assortTabActiveClass);
    });

    Array.prototype.forEach.call(assortTabBodies, function(e) {
      e.style.display = 'none';
    });

    tab.classList.add(assortTabActiveClass);
    tabBody.style.display = 'grid';

    if (id === 3 || id === 4) {
      if (!assortInitTab.classList.contains(assortTabActiveClass)) {
        assortInitTab.classList.add(assortTabActiveClass);
      }
    }

    localStorage.setItem('assortActiveTabId', id.toString());
  };

  var assortActiveTabIdValue = parseInt(localStorage.getItem('assortActiveTabId') || '4');
  var assortTabs = document.querySelectorAll('.js-assort-tab');
  var assortTabActiveClass = '_tab-active';
  var assortInitTab = document.querySelector("[data-target-tab-id=\"1\"]");
  var assortInitChildTab = document.querySelector("[data-target-tab-id=\"4\"]");
  var assortTabBodies = document.querySelectorAll('.js-assort-tab-body');

  Array.prototype.forEach.call(assortTabs, function(e) {
    var tabTargetId = parseInt(e.getAttribute('data-target-tab-id'));
    e.addEventListener('click', function() {
      toggleActiveTab(tabTargetId);
    });
  });

  // Добавляем обработчики событий для новых кнопок
  var toggleButtons = document.querySelectorAll('.js-toggle-assort');
  Array.prototype.forEach.call(toggleButtons, function(button) {
    var targetId = parseInt(button.getAttribute('data-assort-target-id'));
    button.addEventListener('click', function() {
      toggleActiveTab(targetId);
    });
  });

  toggleActiveTab(assortActiveTabIdValue);
}
